module.exports = __webpack_public_path__ + "static/fisherman-two-fish-de483e36b5e124d477ad681f241b1f0e.png";